import React from "react";
import "font-awesome/css/font-awesome.min.css";
import logo from "../assets/new_logo_with_text(3).png"; // Assuming the logo is in the assets folder

const Footer = () => {
  return (
    <footer id="contact" className="bg-primary text-white py-6">
      <div className="container mx-auto px-6 lg:px-20 flex flex-col lg:flex-row justify-between items-center lg:items-center space-y-6 lg:space-y-0">
        {/* Logo Section */}
        <div className="flex flex-col items-center lg:items-start space-y-2">
          <img src={logo} alt="RealEstateApp Logo" className="w-100 h-48" />
        </div>

        {/* Address Section */}
        <div className="flex flex-col items-center lg:items-start space-y-2">
          <h3 className="text-lg font-semibold border-b-2 pb-2">Our Address</h3>
          <p className="text-center lg:text-left">
            Advaitha realtors, 2nd floor, Building No :- 40, 1st Main, 3rd
            Stage, 3rd Block, Basaveshwara Nagar, Bengaluru Urban, Karnataka,
            560079
          </p>
        </div>

        {/* Contact Section */}
        <div className="flex flex-col items-center lg:items-start space-y-2">
          <h3 className="text-lg font-semibold border-b-2 pb-2">Contact Us</h3>
          <div className="flex items-center space-x-2">
            <i className="fa fa-phone"></i>
            <p>9900097989</p>
          </div>
          <div className="flex items-center space-x-2">
            <i className="fa fa-envelope"></i>
            <p>info@advaitharealtors.com</p>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="flex flex-col items-center lg:items-start space-y-2">
          <h3 className="text-lg font-semibold border-b-2 pb-2">
            Connect With Us
          </h3>
          <div className="flex justify-center lg:justify-start space-x-6">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300"
            >
              <i className="fa fa-facebook"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300"
            >
              <i className="fa fa-twitter"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300"
            >
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="text-center mt-6">
        <p>&copy; 2025 Advaitha Relators. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
